const CustomerConstants = {
    status: {
        ALL: 'all',
        ACTIVE: 'active',
        INACTIVE: 'inactive',
    },
    source: {
        ALL: 'all',
        SELF: 'self',
        SUPER: 'super',
        SALES: 'sales',
    },
};
export const convertValueCustomerStatus = (status: string) => {
    switch (status) {
        case CustomerConstants.status.ALL:
            return 'Tất cả';
        case CustomerConstants.status.ACTIVE:
            return 'Đang hoạt động';
        case CustomerConstants.status.INACTIVE:
            return 'Đã khóa';
        default:
            return '';
    }
};

export const convertValueCustomSource = (status: string) => {
    switch (status) {
        case CustomerConstants.source.ALL:
            return 'Tất cả';
        case CustomerConstants.source.SELF:
            return 'Tự đăng ký';
        case CustomerConstants.source.SUPER:
            return 'Quản trị viên';
        case CustomerConstants.source.SALES:
            return 'Kinh doanh';
        default:
            return '';
    }
};

export default CustomerConstants;
